import React from 'react';
import { useLocation } from 'react-router';

function useQueryLocation() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default useQueryLocation;
